export const AD_DETAILS_NOT_FOUND = 'AD_DETAILS_NOT_FOUND';
export const AD_DETAILS_ERROR = 'AD_DETAILS_ERROR';
export const SEARCHBOX_WRONG_URL = 'SEARCHBOX_WRONG_URL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const AUTH_TOKEN_EXPIRED = 'AUTH_TOKEN_EXPIRED';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const SEARCHBOX_WRONG_VIN = 'SEARCHBOX_WRONG_VIN';
